module.exports = __webpack_public_path__ + "fonts/600-normal-latin.603c992.woff2";